import { PHONE_TYPES } from './PhoneNumber';

const formatAddress = (address) => {
  if (address && address.enterManually) {
    return `${address.addressLine} ${address.suburb} ${address.state.label} ${address.postcode}`;
  } else if (address && address.lookupValue && address.lookupValue.label) {
    return address.lookupValue.label;
  } else {
    return '';
  }
};

const formatInternationalAddress = (address) => {
  if (address?.addressType === 'international') {
    const { streetAddress, province, city, country, zipCode } = address.address;
    return `${streetAddress}, ${province && province + ' '}${city && city + ' '}${country} ${zipCode}`;
  }

  return address?.address?.RawAddress?.data?.addressDetails?.formattedAddress;
};

const onlyNumbers = (input) => input.replace(/\D/g, '');

const onlyCharacters = (input) => input.replace(/[^a-zA-Z\  ]/g, '');

const onlyPhoneCharacters = (input) => input.replace(/[^\(\)\+0-9]+/g, '');

const setDigitsAndFocusNext = (event, numDigits, setter, next) => {
  const value = onlyNumbers(event.target.value);
  if (setter) {
    setter(value);
    if (value.length >= numDigits && next) {
      next.current.focus();
    }
  }
};

const formatMoney = (number, decPlaces, decSep, thouSep, symbol) => {
  const decPlaces2 = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces;
  const decSep2 = typeof decSep === 'undefined' ? '.' : decSep;
  thouSep = typeof thouSep === 'undefined' ? ',' : thouSep;
  var sign = number < 0 ? '-' : '';
  var i = String(parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces2))));
  var j = (j = i.length) > 3 ? j % 3 : 0;

  return (
    (symbol || '') +
    sign +
    (j ? i.substr(0, j) + thouSep : '') +
    i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, '$1' + thouSep) +
    (decPlaces2
      ? decSep2 +
        Math.abs(number - i)
          .toFixed(decPlaces2)
          .slice(2)
      : '')
  );
};

const concatName = (name) => {
  return `${name?.firstName || ''} ${`${name?.middleName} ` || ' '}${name?.lastName || ''}`;
};

const getPreferredPhoneNumberByType = (primary, secondary, phoneType) => {
  if (!Object.values(PHONE_TYPES).includes(phoneType)) {
    console.error('Invalid phone number type:', phoneType);
  }

  const numberList = [primary || {}, secondary || {}].filter((phoneNumber) => phoneNumber?.type === phoneType);

  if (!numberList?.length) return null;

  // If one of them is an Australian number, return it.
  for (let number of numberList) {
    if (number.isAustralian) {
      return number.formattedNumber;
    }
  }

  // Otherwise return the first one.
  return numberList[0].formattedNumber;
};

const getQuestionAnswers = (disclosures, disclosuresRefData) => {
  //todo populate these data from ref data
  let questionAnswers = [];
  questionAnswers.push({
    Code: 342,
    Question: '',
    Category: '',
    Answers: ['Yes'],
  });

  return questionAnswers;
};

// Add ':' at the end of each label (TODO: This should be added in the backend.)
const formatSummaryLabels = (sections) => {
  sections.forEach((section) => {
    section.subSections.forEach((subSection) =>
      subSection.details.forEach((details) => {
        if (details.text) details.text = details.text + ':';
      }),
    );
  });
};

const formatBlankFields = (details, removeLabelsOfBlankFields = false) => {
  if (removeLabelsOfBlankFields) {
    return details.filter((prop) => prop.value);
  }

  details.forEach((prop) => (prop.value = prop.value || '-'));
  return details;
};

const formatDeclarations = (consent, stamp, fullName, jobTitle) => {
  consent += `\n###### Full name: ${fullName}`;

  if (jobTitle) {
    consent += `\n###### Job title: ${jobTitle}`;
  }

  return {
    consent,
    stamp,
  };
};

export {
  concatName,
  formatAddress,
  formatInternationalAddress,
  onlyNumbers,
  onlyCharacters,
  onlyPhoneCharacters,
  setDigitsAndFocusNext,
  formatMoney,
  getQuestionAnswers,
  getPreferredPhoneNumberByType,
  formatSummaryLabels,
  formatBlankFields,
  formatDeclarations,
};
